import React from 'react';
import styled from 'styled-components';
import { em } from 'polished';
import PPCCLogo from '../../img/Lightning-Bug-App-Logo-Horizontal.png';

const Image = styled.img`
  height: ${em('50px')};
`;

function Logo() {
  return <Image alt="Pediatric Palliative Care Coalition" src={PPCCLogo} />;
}

export default Logo;



// WEBPACK FOOTER //
// ./src/modules/common/Logo.js